import React, { memo, useEffect, useState } from 'react'

import MatrixUX from '@ublique/components/MatrixUX'

import { isInvalidByField } from '../utils/form'
import { MONTHS } from '../constants'
import { getMonths } from '../utils/options'
import InfoButton from './InfoButton'
import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'

const JobMonths = ({ t, disabled, months, editingValues, setFieldValue }) => {
  const [isMonthly, setIsMonthly] = useState(isEmpty(months))
  // Cleanup values
  useEffect(() => {
    if (isMonthly) {
      setFieldValue(MONTHS, [])
    }
  }, [isMonthly])

  const monthsData = getMonths(t)

  return (
    <MatrixUX
      disabled={disabled || isMonthly}
      id='months'
      labelText={t('Crontab.MONTHS')}
      labelTooltip={<InfoButton message={t('Crontab.Fields.MONTHS_TOOLTIP')} />}
      data={monthsData}
      columns={6}
      multiple
      selected={
        Array.isArray(months) ? months : !isUndefined(months) ? [months] : []
      }
      setSelected={(value) => setFieldValue(MONTHS, value)}
      invalid={isInvalidByField.months({
        value: months,
        disabled,
        isEditing: editingValues[MONTHS]
      })}
      invalidText={t('Crontab.MONTHS_INVALID')}
      canSelectAll
      selectAll={isMonthly}
      onSelectAllChange={setIsMonthly}
      selectAllTooltip={t('Crontab.MONTHLY')}
    />
  )
}

export default memo(JobMonths)
